import React, { useEffect, useState } from "react";
import { X, ChevronDown, ChevronUp } from "lucide-react";
import { ButtonShadcn } from "@/components/ui/Button";

const EntryCard = ({forceOpen, forceOpenTrigger = 0, label, canRemove, onRemove, children, defaultOpen = true,disabled=false }) => {
  const isCollapsible = canRemove; // ← add this back
  const [open, setOpen] = useState(defaultOpen ?? true);

  useEffect(() => {
    if (forceOpen) setOpen(true);
  }, [forceOpen,forceOpenTrigger]);

  return (
    <>
      <div className="rounded-xl px-5 py-1 space-y-5">
        {/* Header */}
        <div className="flex items-center justify-between">
          {/* Left: Title */}
          <span className="text-md font-medium text-text-primary truncate">{label}</span>

          {/* Right: Actions */}
          <div className="flex items-center gap-1 py-2">
            {/* Collapse toggle */}
            {isCollapsible && (
              <ButtonShadcn
                variant="ghost"
                size="icon"
                aria-label={open ? "Collapse" : "Expand"}
                onClick={() => setOpen((prev) => !prev)}
                className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-background-tertiary transition"
              >
                {open ? <ChevronUp size={16} className="text-text-primary" /> : <ChevronDown size={16} className="text-text-primary" />}
              </ButtonShadcn>
            )}

            {/* Remove */}
            {canRemove && (
              <ButtonShadcn
                variant="ghost"
                size="icon"
                aria-label="Remove"
                disabled={disabled}
                onClick={(e) => {
                  e.stopPropagation();
                  onRemove();
                }}
                className="w-7 h-7 flex items-center justify-center rounded-full bg-gray-500/40 hover:bg-red-500/20 hover:text-red-400 text-text-primary transition p-0"
              >
                <X size={14} />
              </ButtonShadcn>
            )}
          </div>
        </div>

        {/* Content */}
        {(open || !isCollapsible) && <div className="space-y-4">{children}</div>}
      </div>

      <hr className="border-border-primary" />
    </>
  );
};

export default EntryCard;
